/* js/install-guides.js — the off-canvas install guides on /install (partials/install-guides.php).
   Shows the guide that was clicked, fills in this site's own snippet (taken from the page's
   <pre data-gs="snippet">, which interactions.js renders for the current site), copy buttons, and a
   Verify button that runs the page's existing check and mirrors its result in the panel. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function siteKey() {
    var k = $('[data-gs="site-key"]');
    return (k && k.value) || (window.GS && GS.site) || '';
  }
  function snippetText() {
    var pre = $('[data-gs="snippet"]'), key = siteKey();
    if (pre && /data-site="[^"]+"/.test(pre.textContent)) return pre.textContent;
    return key ? '<script defer data-site="' + key + '" data-api="https://api.ghoststat.me" src="https://cdn.ghoststat.me/gs.js"></script>' : '';
  }
  function nextText() {
    var key = siteKey(); if (!key) return '';
    return "import Script from 'next/script'\n\n"
      + '<Script\n  src="https://cdn.ghoststat.me/gs.js"\n  data-site="' + key + '"\n'
      + '  data-api="https://api.ghoststat.me"\n  strategy="afterInteractive"\n/>';
  }
  function fill() {
    var s = snippetText(), n = nextText();
    $$('[data-ig-code="snippet"]').forEach(function (p) { p.textContent = s || '…'; });
    $$('[data-ig-code="next"]').forEach(function (p) { p.textContent = n || '…'; });
    $$('[data-ig-code="key"]').forEach(function (p) { p.textContent = siteKey() || '…'; });
  }

  function open(slug) {
    var oc = $('#gsInstallGuide'); if (!oc) return;
    var shown = null;
    $$('[data-ig-guide]', oc).forEach(function (g) {
      var on = g.getAttribute('data-ig-guide') === slug; g.hidden = !on; if (on) shown = g;
    });
    if (!shown) return;
    $('[data-ig="title"]', oc).textContent = shown.getAttribute('data-ig-name');
    var ic = $('[data-ig="icon"] i', oc); if (ic) ic.className = 'bi ' + shown.getAttribute('data-ig-icon');
    var st = $('[data-ig="verify-status"]', oc); if (st) st.hidden = true;
    oc.querySelector('.offcanvas-body').scrollTop = 0;
    fill();
  }

  function init() {
    var oc = $('#gsInstallGuide'); if (!oc) return;
    $$('[data-ig-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(b.getAttribute('data-ig-open')); });
    });

    $$('[data-ig-copy]', oc).forEach(function (b) {
      b.addEventListener('click', function () {
        var pre = b.parentNode.querySelector('pre'); if (!pre || !navigator.clipboard) return;
        navigator.clipboard.writeText(pre.textContent).then(function () {
          b.textContent = b.getAttribute('data-done');
          setTimeout(function () { b.textContent = b.getAttribute('data-label'); }, 1500);
        }, function () {});
      });
    });

    // Verify: the page's own button runs the real check (interactions.js) and writes its badge; copy
    // that badge into the panel whenever it changes, so nobody has to close the panel to see it.
    var mainBtn = $('[data-gs="verify-install"]'), mainSt = $('[data-gs="verify-status"]');
    var vb = $('[data-ig="verify"]', oc), vs = $('[data-ig="verify-status"]', oc);
    function mirror() { if (!mainSt || !vs) return; vs.textContent = mainSt.textContent; vs.className = mainSt.className + ' ms-1'; }
    if (mainSt && vs) new MutationObserver(mirror).observe(mainSt, { childList: true, characterData: true, subtree: true, attributes: true });
    if (vb) vb.addEventListener('click', function () {
      if (vs) { vs.hidden = false; mirror(); }
      if (mainBtn) mainBtn.click();
    });

    // the snippet arrives after the site list loads (gs:ready) or when the site switcher changes
    var pre = $('[data-gs="snippet"]');
    if (pre) new MutationObserver(fill).observe(pre, { childList: true, characterData: true, subtree: true });
    document.addEventListener('gs:site-change', function () { setTimeout(fill, 0); });
    fill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
